import {JRes} from "./Functions";

function _resultToExpectation(json: any, expectation: Expectation): any {
    if (expectation.isArray)
        return json.map((item: any) => {
            return new expectation.class(item)
        });
    else return new expectation.class(json);
}

export abstract class RequestGroup {

    defaultEvents: FetchEvents = {
        onStart: () => { },
        onSuccess: jData => { },
        onResponse: jRes => { },
        onError: err => { },
        onPromiseReject: err => { }
    };

    constructor(props: any) {
        this.defaultEvents = props.defaultEvents;
    }

    customPromise(onDone: Function, expect: Expectation) {
        type singleT = typeof expect.class;
        type arrayT = typeof expect.class[];

        const resolver = (resolve: any, reject: any) => {
            const events: FetchEvents = {...this.defaultEvents};
            events.onSuccess = (jsonData: any) => {
                resolve(_resultToExpectation(jsonData, expect));
            };
            events.onPromiseReject = reject;
            onDone(events);
        }

        if (expect.isArray) return new Promise<arrayT>(resolver);
        else return new Promise<singleT>(resolver)
    }
}


export type FetchEvents = {
    onStart: () => void,
    onResponse: (jRes: JRes) => void,
    onSuccess: (data: any) => void,
    onError: (err: string, code: number) => void,
    onPromiseReject: (err: string) => void
};

export type Expectation = {
    class: any,
    isArray: boolean
};